import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useContentful from "../../Hooks/Contentful";
import "./OrdersPage.css";

const OrdersPage = () => {
  const [filter, setFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [orders, setOrders] = useState([]);

  const { getOrders } = useContentful();

  useEffect(() => {
    getOrders().then((response) => response && setOrders(response));
  }, []);

  const filteredOrders = orders.filter((order) => {
    const orderDate = new Date(order.createdAt);
    const isWithinDateRange =
      (!startDate || orderDate >= startDate) &&
      (!endDate || orderDate <= endDate);
    const matchesFilter =
      order.reference?.toLowerCase().includes(filter.toLowerCase()) ||
      order.accountName?.toLowerCase().includes(filter.toLowerCase());
    const matchesStatus =
      statusFilter === "All" ||
      order.deliverystatus?.toLowerCase() === statusFilter.toLowerCase();
    return matchesFilter && isWithinDateRange && matchesStatus;
  });

  const handleEditOrder = (order) => {
    setSelectedOrder({ ...order });
  };

  const handleSaveOrder = async () => {
    try {
      // POST to your localhost Node.js backend endpoint (update the URL as needed for your setup)
      const response = await fetch("https://lencopay.onrender.com/api/orders/update", {
      //const response = await fetch("http://localhost:2002/api/orders/update", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(selectedOrder),
      });

      if (!response.ok) {
        throw new Error("Failed to update order");
      }

      // Simulate local update
      const updatedOrders = orders.map((o) =>
        o.reference === selectedOrder.reference ? selectedOrder : o
      );
      setOrders(updatedOrders);
      alert("Order updated successfully!");
      setSelectedOrder(null);
    } catch (error) {
      console.error("Error updating order:", error);
      alert("Failed to save changes. Please try again.");
    }
  };

  return (
    <div className="orders-container">
      <h2 className="orders-title">Delivery Management</h2>

      <div className="filters">
        <input
          type="text"
          placeholder="Search by order number or client name"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="filter-input"
        />

        <div className="filter-row">
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="filter-select"
          >
            <option value="All">All Statuses</option>
            <option value="Pending">Pending</option>
            <option value="Dispatched">Dispatched</option>
            <option value="Delivered">Delivered</option>
            <option value="Cancelled">Cancelled</option>
          </select>

          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            placeholderText="Start Date"
            dateFormat="yyyy-MM-dd"
            className="filter-date"
          />
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            placeholderText="End Date"
            dateFormat="yyyy-MM-dd"
            className="filter-date"
          />
        </div>
      </div>

      <div className="orders-grid">
        {filteredOrders.map((order) => (
          <div className="order-card" key={order.reference}>
            <div className="order-header">
              <h4>{order.reference}</h4>
              <span className={`status-badge ${order.paymentstatus?.toLowerCase()}`}>
                {order.paymentstatus}
              </span>
            </div>
            <p><strong>Client:</strong> {order.accountName}</p>
            <p><strong>Phone:</strong> {order.phone}</p>
            <p><strong>Date:</strong> {order.createdAt}</p>
            <p><strong>Delivery:</strong> {order.deliverystatus || "Pending"}</p>
            <button onClick={() => handleEditOrder(order)} className="btn-view">
              Edit / View
            </button>
          </div>
        ))}
      </div>
      {selectedOrder && (
  <div className="modal">
    <div className="modal-content">
      <span className="close" onClick={() => setSelectedOrder(null)}>
        &times;
      </span>

      <h3>Edit Order – {selectedOrder.reference}</h3>

      {/* CUSTOMER INFO */}
      <label>Customer Name</label>
      <input
        className="input"
        value={selectedOrder.fullName || ""}
        disabled
      />

      <label>Phone</label>
      <input
        className="input"
        value={selectedOrder.phone || ""}
        disabled
      />

      {/* DELIVERY ADDRESS */}
      <h4 style={{ marginTop: "15px" }}>Delivery Address</h4>

      <label>Street / Area</label>
      <input
        className="input"
        value={selectedOrder.street || ""}
        onChange={(e) =>
          setSelectedOrder({ ...selectedOrder, street: e.target.value })
        }
      />

      <label>City</label>
      <input
        className="input"
        value={selectedOrder.city || ""}
        onChange={(e) =>
          setSelectedOrder({ ...selectedOrder, city: e.target.value })
        }
      />

      <label>Province</label>
      <input
        className="input"
        value={selectedOrder.province || ""}
        onChange={(e) =>
          setSelectedOrder({ ...selectedOrder, province: e.target.value })
        }
      />

      <label>Postal Code</label>
      <input
        className="input"
        value={selectedOrder.postalCode || ""}
        onChange={(e) =>
          setSelectedOrder({ ...selectedOrder, postalCode: e.target.value })
        }
      />

      <label>Additional Info</label>
      <textarea
        className="input"
        rows="2"
        value={selectedOrder.additionalInfo || ""}
        onChange={(e) =>
          setSelectedOrder({
            ...selectedOrder,
            additionalInfo: e.target.value,
          })
        }
      />

      {/* DELIVERY STATUS */}
      <h4 style={{ marginTop: "15px" }}>Delivery</h4>

      <label>Delivery Status</label>
      <select
        className="input"
        value={selectedOrder.deliverystatus || "Pending"}
        onChange={(e) =>
          setSelectedOrder({
            ...selectedOrder,
            deliverystatus: e.target.value,
          })
        }
      >
        <option value="Pending">Pending</option>
        <option value="Dispatched">Dispatched</option>
        <option value="Delivered">Delivered</option>
        <option value="Cancelled">Cancelled</option>
      </select>

      <label>Estimated Delivery Date</label>
      <DatePicker
        selected={
          selectedOrder.estimatedDeliveryDate
            ? new Date(selectedOrder.estimatedDeliveryDate)
            : null
        }
        onChange={(date) =>
          setSelectedOrder({
            ...selectedOrder,
            estimatedDeliveryDate: date,
          })
        }
        className="input"
        dateFormat="yyyy-MM-dd"
      />

      <button onClick={handleSaveOrder} className="btn-save">
        Save Changes
      </button>
    </div>
  </div>
)}


      {/* {selectedOrder && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={() => setSelectedOrder(null)}>
              &times;
            </span>
            <h3>Edit Order - {selectedOrder.reference}</h3>

            <label>Delivery Address</label>
            <textarea
              value={selectedOrder.address || ""}
              onChange={(e) =>
                setSelectedOrder({ ...selectedOrder, address: e.target.value })
              }
              rows="3"
              className="input"
            />

            <label>Delivery Status</label>
            <select
              value={selectedOrder.deliveryStatus || "Pending"}
              onChange={(e) =>
                setSelectedOrder({
                  ...selectedOrder,
                  deliveryStatus: e.target.value,
                })
              }
              className="input"
            >
              <option value="Pending">Pending</option>
              <option value="Dispatched">Dispatched</option>
              <option value="Delivered">Delivered</option>
              <option value="Cancelled">Cancelled</option>
            </select>

            <label>Estimated Delivery Date</label>
            <DatePicker
              selected={
                selectedOrder.estimatedDeliveryDate
                  ? new Date(selectedOrder.estimatedDeliveryDate)
                  : null
              }
              onChange={(date) =>
                setSelectedOrder({
                  ...selectedOrder,
                  estimatedDeliveryDate: date,
                })
              }
              className="input"
              dateFormat="yyyy-MM-dd"
            />

            <button onClick={handleSaveOrder} className="btn-save">
              Save Changes
            </button>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default OrdersPage;

// import React, { useState, useEffect } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import useContentful from "../../Hooks/Contentful";
// import "./OrdersPage.css";

// const OrdersPage = () => {
//   const [filter, setFilter] = useState("");
//   const [statusFilter, setStatusFilter] = useState("All");
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [orders, setOrders] = useState([]);

//   const { getOrders } = useContentful();

//   useEffect(() => {
//     getOrders().then((response) => response && setOrders(response));
//   }, []);

//   const filteredOrders = orders.filter((order) => {
//     const orderDate = new Date(order.createdAt);
//     const isWithinDateRange =
//       (!startDate || orderDate >= startDate) &&
//       (!endDate || orderDate <= endDate);
//     const matchesFilter =
//       order.reference?.toLowerCase().includes(filter.toLowerCase()) ||
//       order.accountName?.toLowerCase().includes(filter.toLowerCase());
//     const matchesStatus =
//       statusFilter === "All" ||
//       order.deliveryStatus?.toLowerCase() === statusFilter.toLowerCase();
//     return matchesFilter && isWithinDateRange && matchesStatus;
//   });

//   const handleEditOrder = (order) => {
//     setSelectedOrder({ ...order });
//   };

//   const handleSaveOrder = async () => {
//     try {
//       // Dummy POST endpoint for simulation
//     const response = await fetch("http://localhost:2002/payment", {
//       //const response = await fetch("https://jsonplaceholder.typicode.com/posts", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(selectedOrder),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to update order");
//       }

//       // Simulate local update
//       const updatedOrders = orders.map((o) =>
//         o.reference === selectedOrder.reference ? selectedOrder : o
//       );
//       setOrders(updatedOrders);
//       alert("Order updated successfully!");
//       setSelectedOrder(null);
//     } catch (error) {
//       console.error("Error updating order:", error);
//       alert("Failed to save changes. Please try again.");
//     }
//   };

//   return (
//     <div className="orders-container">
//       <h2 className="orders-title">Delivery Management</h2>

//       <div className="filters">
//         <input
//           type="text"
//           placeholder="Search by order number or client name"
//           value={filter}
//           onChange={(e) => setFilter(e.target.value)}
//           className="filter-input"
//         />

//         <div className="filter-row">
//           <select
//             value={statusFilter}
//             onChange={(e) => setStatusFilter(e.target.value)}
//             className="filter-select"
//           >
//             <option value="All">All Statuses</option>
//             <option value="Pending">Pending</option>
//             <option value="Dispatched">Dispatched</option>
//             <option value="Delivered">Delivered</option>
//             <option value="Cancelled">Cancelled</option>
//           </select>

//           <DatePicker
//             selected={startDate}
//             onChange={(date) => setStartDate(date)}
//             placeholderText="Start Date"
//             dateFormat="yyyy-MM-dd"
//             className="filter-date"
//           />
//           <DatePicker
//             selected={endDate}
//             onChange={(date) => setEndDate(date)}
//             placeholderText="End Date"
//             dateFormat="yyyy-MM-dd"
//             className="filter-date"
//           />
//         </div>
//       </div>

//       <div className="orders-grid">
//         {filteredOrders.map((order) => (
//           <div className="order-card" key={order.reference}>
//             <div className="order-header">
//               <h4>{order.reference}</h4>
//               <span className={`status-badge ${order.paymentstatus?.toLowerCase()}`}>
//                 {order.paymentstatus}
//               </span>
//             </div>
//             <p><strong>Client:</strong> {order.accountName}</p>
//             <p><strong>Phone:</strong> {order.phone}</p>
//             <p><strong>Date:</strong> {order.createdAt}</p>
//             <p><strong>Delivery:</strong> {order.deliveryStatus || "Pending"}</p>
//             <button onClick={() => handleEditOrder(order)} className="btn-view">
//               Edit / View
//             </button>
//           </div>
//         ))}
//       </div>

//       {selectedOrder && (
//         <div className="modal">
//           <div className="modal-content">
//             <span className="close" onClick={() => setSelectedOrder(null)}>
//               &times;
//             </span>
//             <h3>Edit Order - {selectedOrder.reference}</h3>

//             <label>Delivery Address</label>
//             <textarea
//               value={selectedOrder.address || ""}
//               onChange={(e) =>
//                 setSelectedOrder({ ...selectedOrder, address: e.target.value })
//               }
//               rows="3"
//               className="input"
//             />

//             <label>Delivery Status</label>
//             <select
//               value={selectedOrder.deliveryStatus || "Pending"}
//               onChange={(e) =>
//                 setSelectedOrder({
//                   ...selectedOrder,
//                   deliveryStatus: e.target.value,
//                 })
//               }
//               className="input"
//             >
//               <option value="Pending">Pending</option>
//               <option value="Dispatched">Dispatched</option>
//               <option value="Delivered">Delivered</option>
//               <option value="Cancelled">Cancelled</option>
//             </select>

//             <label>Estimated Delivery Date</label>
//             <DatePicker
//               selected={
//                 selectedOrder.estimatedDeliveryDate
//                   ? new Date(selectedOrder.estimatedDeliveryDate)
//                   : null
//               }
//               onChange={(date) =>
//                 setSelectedOrder({
//                   ...selectedOrder,
//                   estimatedDeliveryDate: date,
//                 })
//               }
//               className="input"
//               dateFormat="yyyy-MM-dd"
//             />

//             <button onClick={handleSaveOrder} className="btn-save">
//               Save Changes
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrdersPage;


// import React, { useState, useEffect } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import useContentful from "../../Hooks/Contentful";
// import "./OrdersPage.css";

// const OrdersPage = () => {
//   const [filter, setFilter] = useState("");
//   const [statusFilter, setStatusFilter] = useState("All");
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [orders, setOrders] = useState([]);

//   const { getOrders } = useContentful();

//   useEffect(() => {
//     getOrders().then((response) => response && setOrders(response));
//   }, []);

//   const filteredOrders = orders.filter((order) => {
//     const orderDate = new Date(order.createdAt);
//     const isWithinDateRange =
//       (!startDate || orderDate >= startDate) &&
//       (!endDate || orderDate <= endDate);
//     const matchesFilter =
//       order.reference?.toLowerCase().includes(filter.toLowerCase()) ||
//       order.accountName?.toLowerCase().includes(filter.toLowerCase());
//     const matchesStatus =
//       statusFilter === "All" ||
//       order.deliveryStatus?.toLowerCase() === statusFilter.toLowerCase();
//     return matchesFilter && isWithinDateRange && matchesStatus;
//   });

//   const handleEditOrder = (order) => {
//     setSelectedOrder({ ...order });
//   };

//   const handleSaveOrder = () => {
//     // Here you’d call your backend update API
//     const updatedOrders = orders.map((o) =>
//       o.reference === selectedOrder.reference ? selectedOrder : o
//     );
//     setOrders(updatedOrders);
//     setSelectedOrder(null);
//   };

//   return (
//     <div className="orders-container">
//       <h2 className="orders-title">Delivery Management</h2>

//       <div className="filters">
//         <input
//           type="text"
//           placeholder="Search by order number or client name"
//           value={filter}
//           onChange={(e) => setFilter(e.target.value)}
//           className="filter-input"
//         />

//         <div className="filter-row">
//           <select
//             value={statusFilter}
//             onChange={(e) => setStatusFilter(e.target.value)}
//             className="filter-select"
//           >
//             <option value="All">All Statuses</option>
//             <option value="Pending">Pending</option>
//             <option value="Dispatched">Dispatched</option>
//             <option value="Delivered">Delivered</option>
//             <option value="Cancelled">Cancelled</option>
//           </select>

//           <DatePicker
//             selected={startDate}
//             onChange={(date) => setStartDate(date)}
//             placeholderText="Start Date"
//             dateFormat="yyyy-MM-dd"
//             className="filter-date"
//           />
//           <DatePicker
//             selected={endDate}
//             onChange={(date) => setEndDate(date)}
//             placeholderText="End Date"
//             dateFormat="yyyy-MM-dd"
//             className="filter-date"
//           />
//         </div>
//       </div>

//       <div className="orders-grid">
//         {filteredOrders.map((order) => (
//           <div className="order-card" key={order.reference}>
//             <div className="order-header">
//               <h4>{order.reference}</h4>
//               <span className={`status-badge ${order.paymentstatus.toLowerCase()}`}>
//                 {order.paymentstatus}
//               </span>
//             </div>
//             <p><strong>Client:</strong> {order.accountName}</p>
//             <p><strong>Phone:</strong> {order.phone}</p>
//             <p><strong>Date:</strong> {order.createdAt}</p>
//             <p><strong>Delivery:</strong> {order.deliveryStatus || "Pending"}</p>
//             <button onClick={() => handleEditOrder(order)} className="btn-view">
//               Edit / View
//             </button>
//           </div>
//         ))}
//       </div>

//       {selectedOrder && (
//         <div className="modal">
//           <div className="modal-content">
//             <span className="close" onClick={() => setSelectedOrder(null)}>
//               &times;
//             </span>
//             <h3>Edit Order - {selectedOrder.reference}</h3>

//             <label>Delivery Address</label>
//             <textarea
//               value={selectedOrder.address || ""}
//               onChange={(e) =>
//                 setSelectedOrder({ ...selectedOrder, address: e.target.value })
//               }
//               rows="3"
//               className="input"
//             />

//             <label>Delivery Status</label>
//             <select
//               value={selectedOrder.deliveryStatus || "Pending"}
//               onChange={(e) =>
//                 setSelectedOrder({ ...selectedOrder, deliveryStatus: e.target.value })
//               }
//               className="input"
//             >
//               <option value="Pending">Pending</option>
//               <option value="Dispatched">Dispatched</option>
//               <option value="Delivered">Delivered</option>
//               <option value="Cancelled">Cancelled</option>
//             </select>

//             <label>Estimated Delivery Date</label>
//             <DatePicker
//               selected={
//                 selectedOrder.estimatedDeliveryDate
//                   ? new Date(selectedOrder.estimatedDeliveryDate)
//                   : null
//               }
//               onChange={(date) =>
//                 setSelectedOrder({ ...selectedOrder, estimatedDeliveryDate: date })
//               }
//               className="input"
//               dateFormat="yyyy-MM-dd"
//             />

//             <button onClick={handleSaveOrder} className="btn-save">
//               Save Changes
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrdersPage;
